var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-list"},[(_vm.haveFilters)?_c('CallCenterFilter'):_vm._e(),_c('CallCenterTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }